import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BarChart3, 
  Users, 
  TrendingUp, 
  Award,
  ArrowRight,
  Building2
} from 'lucide-react';

const CoachingDashboardCard = ({ userProfile }) => {
  // Check if user has access to coaching dashboard
  const hasCoachingAccess = userProfile?.role === 'admin' || 
                           userProfile?.role === 'founder' || 
                           userProfile?.role === 'teacher' ||
                           userProfile?.coachingId;

  if (!hasCoachingAccess) {
    return null;
  }

  // Determine coaching ID - use from profile or default for admins
  const coachingId = userProfile?.coachingId || 'default-coaching';

  return (
    <div className="bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg shadow-sm p-6 text-white">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-white/20 rounded-lg">
            <Building2 className="w-6 h-6" />
          </div>
          <div>
            <h3 className="text-lg font-semibold">Coaching Dashboard</h3>
            <p className="text-blue-100 text-sm">
              {userProfile?.role === 'teacher' ? 'Coach Performance' : 'Business Intelligence'}
            </p>
          </div>
        </div>
        <Link
          to={`/coaching/${coachingId}`}
          className="flex items-center space-x-1 px-3 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors"
        >
          <span className="text-sm font-medium">Open</span>
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-white/10 rounded-lg p-3">
          <div className="flex items-center space-x-2 mb-1">
            <BarChart3 className="w-4 h-4" />
            <span className="text-sm font-medium">Analytics</span>
          </div>
          <p className="text-xs text-blue-100">
            Revenue, performance & insights
          </p>
        </div>

        <div className="bg-white/10 rounded-lg p-3">
          <div className="flex items-center space-x-2 mb-1">
            <Users className="w-4 h-4" />
            <span className="text-sm font-medium">Management</span>
          </div>
          <p className="text-xs text-blue-100">
            Students, coaches & operations
          </p>
        </div>
      </div>

      {userProfile?.role === 'teacher' && (
        <div className="mt-4 p-3 bg-white/10 rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium">Your Performance</p>
              <p className="text-xs text-blue-100">Track your coaching metrics</p>
            </div>
            <TrendingUp className="w-5 h-5" />
          </div>
        </div>
      )}

      {(userProfile?.role === 'admin' || userProfile?.role === 'founder') && (
        <div className="mt-4 p-3 bg-white/10 rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium">Business Intelligence</p>
              <p className="text-xs text-blue-100">Complete coaching analytics</p>
            </div>
            <Award className="w-5 h-5" />
          </div>
        </div>
      )}
    </div>
  );
};

export default CoachingDashboardCard;